import { useMemo } from "react";

import { useInfo } from "./info";

const CODES = {
  SERIAL_1: "CPDM1001",
  SERIAL_2: "CPDM1002",
};

export const useApiTranslation = () => {
  const {
    commonInfo: { messages },
  } = useInfo();

  const translations = useMemo(
    () =>
      messages.reduce(
        (result, { messageCode, messageTranslation }) => ({
          ...result,
          [messageCode]: messageTranslation,
        }),
        {},
      ),
    [messages],
  );

  const tApi = (code) => translations[CODES[code]];

  return { tApi };
};
